module.exports = __webpack_public_path__ + "img/Testbild.17e1f525.jpg";